import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import styles from './WarningCard.module.scss';

const WarningCard: FC<IProps> = (props) => {
    return (
        <div className={classNames(styles.warningCard, props.className)}>
            <div className={styles.title}>
                What happened?
            </div>
            <div className={styles.description}>
                Transaction was not found or the exact amount was not received.
            </div>
        </div>
    );
};

export default WarningCard;
